import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle,
  faTimesCircle,
  faHourglassStart,
} from '@fortawesome/pro-solid-svg-icons'

import { EnrolEvaluationState } from 'enum'
import { prefix } from '../../constants'
import { EvaluationsDetailModal } from './EvaluationsDetailModal'
import styles from './Evaluations.module.scss'

interface EvaluationsProps {
  state?: number | null
  courseId: string
  userId: string
  user: {
    name?: string | null
    lastname?: string | null
    avatar?: string | null
    position?: string | null
  }
}

export const Evaluations = ({
  state,
  courseId,
  userId,
  user,
}: EvaluationsProps) => {
  const { t } = useTranslation()
  const prefixColumns = `${prefix}.columns`
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { Approved, Failed } = EnrolEvaluationState

  const handleClick = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <div
        className={styles.evaluationResultsContainer}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick()
          }
        }}
      >
        <div className={styles.state}>
          <FontAwesomeIcon
            className="mr-1"
            icon={
              state === Approved
                ? faCheckCircle
                : state === Failed
                ? faTimesCircle
                : faHourglassStart
            }
            color={
              state === Approved
                ? '#00B47C'
                : state === Failed
                ? '#F5222D'
                : '#FAAD14'
            }
          />
          {t(
            `${prefixColumns}.evaluations.states_v2.${
              state === Approved
                ? 'approved'
                : state === Failed
                ? 'failed'
                : 'inProcess'
            }`
          )}
        </div>
      </div>
      {isModalOpen && (
        <EvaluationsDetailModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          courseId={courseId}
          userId={userId}
          user={user}
        />
      )}
    </>
  )
}
